import toast from '../../components/toast/toast'
import '../../components/map/map'
import TimerSelector from './components/timer_selector/timer_selector';
import store from './store/store';


export var MapController = {
  // var obj_highlight = null;
  // this.obj_highlight = null;
  ugrhis_features_list: [],
  citys_features_list: {},
  showMarkersOnMap: function(){
    markers_group.clearLayers();
    markers_pulse_group.clearLayers();
    markers_aux = [];
    const animatedCircleIcon = {
      icon: L.divIcon({
        className: "css-icon",
        html: '<div class="gps_ring"></div>',
        iconSize: [30, 30]
      })
		};
    $.each(measurements, function(index, measurement){
      if(measurement.show){

        var options = {
          isAlphaNumericIcon: true,
          // borderWidth: 4,
          textColor: "white",
          borderWidth: 1,
          text: parseFloat(measurement.value).toFixed(0),
          innerIconStyle: 'margin-top:0;font-size:13px;',
          borderColor: 'white',
          backgroundColor: MapController.getColor(measurement.value),
        };

        var opcoes_marker = {
          title: measurement.prefix,
          station_prefix_id: measurement.station_prefix_id,
          icon: L.BeautifyIcon.icon(options)
        };

        if (measurements.length < 100){
          markers_pulse_group.addLayer(L.marker([measurement.latitude, measurement.longitude], animatedCircleIcon))
        }

        
        let popup_html = "Prefixo: <b>" +measurement.prefix+
        "</b><br>Município: <b>"+measurement.city+
        "</b><br>Acum. no Periodo: <span style='font-weight:bold;color:blue'>"+parseFloat(measurement.value).toFixed(1)+" mm</span>"+
        "<br>Última medição: <b>"+new Date(measurement.max_date).toLocaleString()+"</b>"+
        '<br><br><button type="button" style="width:50px" class="btn btn-outline-info btn-sm btn-open-modal-chart mr-1" data-toggle="modal" data-target="#modal_chart" data-id="'+measurement.station_prefix_id+'"><i class="fas fa-chart-bar"></i></button>'+
        '<a href="/sibh/stations/'+measurement.station_prefix_id+'" target="_blank" class="btn btn-outline-primary btn-sm mr-1" style="width:50px"><i class="fas fa-info"></i></a>'
        if(CAN_REPORT){
          popup_html += '<button data-id="'+measurement.station_prefix_id+'" class="btn btn-outline-danger btn-sm btn-report-station" style="width:50px" title="reportar informações"><i class="fas fa-exclamation"></i></button>'
        }
        var marker = L.marker([measurement.latitude, measurement.longitude],opcoes_marker)
        .bindPopup(
          popup_html
        );

        markers_group.addLayer(marker);
        markers_aux.push(marker);
      }

    })
  },
  getColor: function(value){
		if(value <= 10){
			return "var(--success)"
		} else if (value <= 30) {
			return "#fcb900"
		} else if (value <=	 70) {
			return "#ff7b00"
		} else {
			return "red"
		}
	},
  loadLayerEstateLimits: function(){
    let map_c = new MapComponent({container:'section'})
    map_c.getLimitFeature('state', {simplified:true},{color: "#545454",fillColor: "#8998fa", fillOpacity:0.1, weight: 1.5}).then(featureGroup=>{
      featureGroup.addTo(map)
      featureGroup.id = 'state_limit'
      setTimeout(_=>{
        if(featureGroup.getBounds().isValid()){
          map.fitBounds(featureGroup.getBounds())
        }
      }, 500)
      
    })

  },
  // ###################################### FILTER FUNCTIONS #########################################
  filterMeasurements: function(){
    $(".dom-element-qtdfilter").remove();
    var count = 0;
    $.each(measurements, function(index, measurement){
      
      var valid = true;
      $.each(availableFilters, function(index, filter){
        
        if(!measurement[filter] && measurement[filter] != undefined){
          valid = false;
        }
      })
      measurement.show = valid
      count = (valid) ? count + 1 : count
    })
    if(measurements.length > count){
        this.addElementQtdFilter(count)
    }
  },
  filterMeasurementsByLegends: function(values){
    $.each(measurements, function(index, measurement){
      var valid = false;
      $.each(values, function(index, value){
        // console.log(value)
        switch(value){
          case 0:
            if(measurement.value > 0 && measurement.value <= 10) valid = true
            break;
          case 1:
            if(measurement.value > 10 && measurement.value <= 30) valid = true
            break;
          case 2:
            if(measurement.value > 30 && measurement.value <= 70) valid = true
            break;
          default:
            if(measurement.value >= 70) valid = true
            break;
        }
      })
      measurement.valid_by_legend = valid

    })
    // this.showMarkersOnMap();
  },
  filterMeasurementsByUgrhis: function(ugrhis_cods){
    if(ugrhis_cods.length > 0){
      measurements.map(x=>x.valid_by_ugrhi = ugrhis_cods.map(Number).includes(x.ugrhi_cod) ? true : false)
    } else {
      measurements.map(x=>x.valid_by_ugrhi = true)
    }
  },
  filterMeasurementsByCities: function(ids){
    if(ids.length > 0){
      measurements.map(x=>x.valid_by_city = ids.map(Number).includes(parseInt(x.city_ibge)) ? true : false)
    } else {
      measurements.map(x=>x.valid_by_city = true)
    }
  },
  // ###################################### FILTER FUNCTIONS #########################################


  // ###################################### ADD ELEMENTS MAP FUNCTIONS #########################################
  addLayerControl: function(){
	    var l = [];
	    for (var providerId in providers) {
	      l.push(providers[providerId]);
	    }

	    var ctrl = L.control.iconLayers(l, {position: 'bottomleft'}).addTo(map);
	},
  addElementPointsWithRain: function(measurements){
    $(".dom-element-default.element-pointswithrain").remove();
		var points_element = L.control({position: 'topright'});
		var max_element = L.control({position: 'topright'});

		points_element.onAdd = function (map) {
      var div = L.DomUtil.create('div', 'dom-element-default element-pointswithrain');

      div.innerHTML += "<div><b>PONTOS COM CHUVA</b></div>"
      div.innerHTML += "<div style='text-align:center'><h2 style='color:var(--warning);margin-bottom:0px'>"+measurements.length+"</h2></div>"

      return div;
    };
    if(measurements.length > 0){
    	max_element.onAdd = function (map){
	    	var div = L.DomUtil.create('div', 'dom-element-default element-pointswithrain dom-element-max');
	    	var obj_max = measurements.reduce(function(p,c){ return ((parseFloat(p.value) > parseFloat(c.value)) ? p : c) })
	    	var obj_min = measurements.reduce(function(p,c){ return ((parseFloat(p.value) < parseFloat(c.value)) ? p : c) })

	    	div.innerHTML += "<div><b>Acum. Max: <a style='color:var(--warning); cursor:pointer' id='acum_max' posto_id="+obj_max.station_prefix_id+">"+parseFloat(obj_max.value).toFixed(1)+"</a> mm</b></div>"
	    	div.innerHTML += "<div><b>Acum. Mín: <span style='color:var(--warning); cursor:pointer' id='acum_min' posto_id="+obj_min.station_prefix_id+">"+parseFloat(obj_min.value).toFixed(1)+"</span> mm</b></div>"

	    	return div;
	    }
      max_element.addTo(map);
    }
    points_element.addTo(map);
    
    // if(lista_medicoes.length > 0) max_element.addTo(mapa_chuva_agora);
  },
  addElementLegends: function(){
    //CRIANDO LOCALIZAÇÃO DE DOM ADICIONAL
    var corners = map._controlCorners;
    var l = 'leaflet-';
    var container = map._controlContainer;
    var className = l + "horizontalcenter" + ' ' + l + "bottom";
    corners["horizontalcenter" + "bottom"] = L.DomUtil.create('div', className, container);
	    //CRIADO

		var legends = L.control({position: 'horizontalcenterbottom'});

		legends.onAdd = function (map){
      var div = L.DomUtil.create('div', 'legend-stations');
      div.innerHTML += "<span style='font-size:16px;font-weight:bold;display:block;text-align:center;background-color:black;color:white;border-radius:5px 5px 0px 0px'>LEGENDAS</span>"+
      "<div id='legend_ok' class='legend active' data-id='0'>Abaixo 10 mm</div>"+
      "<div id='legend_moderate' class='legend active' data-id='1'>De 10 mm a 30 mm</div>"+
      "<div id='legend_alert' class='legend active' data-id='2'>De 30 mm a 70 mm</div>"+
      "<div id='legend_danger' class='legend active' data-id='3'>Acima 70 mm</div>";

      return div;
    }

    legends.addTo(map);
  },
  addElementUgrhi: function(){
    $(".dom-element-default.dom-element-ugrhi").remove();
    var ugrhi_element = L.control({position: 'bottomleft'})
		ugrhi_element.onAdd = function(){
  	var div = L.DomUtil.create('div', 'dom-element-default dom-element-ugrhi');
    	div.innerHTML += "<div style=''><b>UGRHIS</b></div>";
    	// div.innerHTML += '<label for="customRange2">Example range</label><input type="range" class="custom-range" min="0" max="5" id="customRange2">'
    	return div;
    }
    ugrhi_element.addTo(map);
  },
  addElementCity: function(){
    $(".dom-element-default.dom-element-city").remove();
    var city_element = L.control({position: 'bottomleft'})
		city_element.onAdd = function(){
  	var div = L.DomUtil.create('div', 'dom-element-default dom-element-city');
    	div.innerHTML += "<div style=''><b>Limites</b></div><div class='loader loader-layer' style='float:right;display:none'></div>";
    	div.innerHTML += "<div><input type='checkbox' id='checkbox_city_limit' style='vertical-align: middle;margin:0px' /> Municípios</div>";
      div.innerHTML += "<div><input type='checkbox' id='checkbox_ugrhi_limit' style='vertical-align: middle;margin:0px'/> Ugrhis</div>";
      
    	// div.innerHTML += '<label for="customRange2">Example range</label><input type="range" class="custom-range" min="0" max="5" id="customRange2">'
    	return div;
    }
    city_element.addTo(map);
  },
  addElementFilter: function(){
    var filter_element = L.control({position: 'topleft'})
		filter_element.onAdd = function(){
    	var div = L.DomUtil.create('div', 'dom-element-filter dom-element-group');

    	div.innerHTML += "<div class='dom-element-group-item btn-open-filter'><i class='fas fa-filter'></i></div>";
      
      // div.innerHTML += "<div class='dom-element-group-item btn-open-config'><i class='fas fa-cog'></i></div>";

      // div.innerHTML += '<div class="btn-hide-boxes dom-element-group-item" data-value="hide" title="Esconder elementos informativos"><i class="fas fa-eye-slash"></i></div>'

    	return div;
    }
    
    filter_element.addTo(map)
    
    $(filter_element._container).find('.btn-open-filter').on('click', _=>{
      //botao filter clicked
      $(document).trigger('map:open_filter')
    })

    // $(filter_element._container).find('.btn-open-config').on('click', _=>{
    //   //botao filter clicked
    //   $(document).trigger('open_config')
    // })

  },
  addElementMonitoredSpots: function(){
		// $(".dom-element-esconder-caixas").remove();
		var element = L.control({position: 'bottomright'})
		element.onAdd = function () {
    	var div = L.DomUtil.create('div', 'dom-element-default dom-element-monitored');

    	div.innerHTML += "<div>Pontos monitorados <input type='checkbox' id='checkbox_monitored_spots' style='vertical-align: middle;margin:0px'></input></div><div class='loader loader-monitored' style='float:right;display:none'></div>";

    	return div;
    }
    element.addTo(map);
    
	},
  addElementHours: function(){
    var hour_element = L.control({position: 'bottomright'})
		hour_element.onAdd = function(){
      
    	var div = L.DomUtil.create('div', 'dom-element-default time-control-container fit-content');

      let timerSelector = new TimerSelector({container:div})
      timerSelector.generate()

      store.mainConfigStore.subscribe('TYPE_UPDATE', data=>{
        if(data == 'flu'){
          timerSelector.hideOptions([1,2,3,12,24,48,72])
          
        } else {
          timerSelector.hideOptions([])
        }
      })


      return div;
    }
    hour_element.addTo(map)
  },
  addElementQtdFilter: function(value){

		var element = L.control({position: 'topleft'})
		element.onAdd = function(){
    	var div = L.DomUtil.create('div', 'dom-element-default dom-element-qtdfilter');

    	div.innerHTML += "Qtd. Filtrados: <span style='color:#3c8dbc'>" + value + "</span>";

    	return div;
    }
    element.addTo(map)
  },
  addElementHideBoxes: function(){
    $(".dom-element-hide-boxes").remove();
		var element = L.control({position: 'topleft'})
		element.onAdd = function(){
    	var div = L.DomUtil.create('div', 'dom-element-hide-boxes');

    	div.innerHTML += '<div id="btn_hide_boxes" data-value="hide" title="Esconder elementos informativos"><i class="fas fa-eye-slash"></i></div>';

    	return div;
    }
    element.addTo(map)
  },
  addElementUpdatedAt: function(){
    $(".dom-element-updatedat").remove();
    if(measurements.length > 0){
      var element = L.control({position: 'topright'})
      element.onAdd = function(){
        var div = L.DomUtil.create('div', 'dom-element-updatedat');

        // div.innerHTML += '<div>Atualizado em: <b><i>'+getUpdatedAt()+'</i></b></div>';
        div.innerHTML += '  ';

        return div;
      }
      element.addTo(map)
    }
    function getUpdatedAt(){
      let newest_measurement = measurements.reduce((a,b)=> new Date(a.max_date) > new Date(b.max_date) ? a : b )
      return new Date(newest_measurement.max_date).toLocaleString()// supondo que a data estara no fuso GMT
    }    
  },
  setUpdatedAt(){
    $('.date-container .text').html(`<i class="fas fa-clock mr-2"></i><b><i>${getUpdatedAt()}</i></b>`)
    function getUpdatedAt(){
      // let newest_measurement = measurements.reduce((a,b)=> new Date(a.max_date) > new Date(b.max_date) ? a : b )
      return new Date().toLocaleString().slice(0, -3);// supondo que a data estara no fuso GMT
    } 
  },
  // ###################################### ADD ELEMENTS MAP FUNCTIONS #########################################



  // ###################################### LOAD LAYERS FOR MAP FUNCTIONS #########################################
  loadUgrhisLayer: function(ugrhis_cods=[]){

    let STYLE_UGRHI_LAYER = {color: "#545454",fillColor: "#6ecaff", fillOpacity:0.3, weight: 1.5}

    function bounds(){
      setTimeout(_=>{
        if(featureGroupUgrhiLimit.getBounds().isValid()){
          map.fitBounds(featureGroupUgrhiLimit.getBounds())
        }
      }, 100)
      $(".loader-layer").hide();
    }
    
    //função para adicionar geometrias ao mapa CASO filtrada pelo usuário
    let addToMap = cods =>{
      featureGroupCityLimit.clearLayers()
      this.ugrhis_features_list.forEach(feature=>{
        if(cods.includes(feature.codigo.toString())){
          featureGroupUgrhiLimit.addLayer(feature)
        }
      })
    }

    //featureGroupUgrhiLimit ta global :(
    let map_c = new MapComponent({container: '.whatever'}) //n será usado para criar mapa

    //limpando camada de ugrhis
    featureGroupUgrhiLimit.clearLayers()

    //verificando dos códigos filtrados, qual eu NÃO tenho a geometria
    let ugrhis_needed = ugrhis_cods.filter(c=> !this.ugrhis_features_list.some(item=>item.codigo == c))
    console.log(ugrhis_needed);
    //se tem alguma geometria que eu não tenho, buscar
    if(ugrhis_needed.length > 0){
      map_c.getLimitFeature('ugrhi', {simplified:true, ugrhi_cods:ugrhis_needed},STYLE_UGRHI_LAYER).then(featureGroup=>{        
        
        //adicinando novas geometrias a camada de geometrias
        featureGroup.eachLayer(feature=>{
          this.ugrhis_features_list.push(feature)
        })
        
        addToMap(ugrhis_cods)

        //bounds
        bounds()
      })
    } else {
      addToMap(ugrhis_cods)

      //bounds
      bounds()
    }
    
  },
  loadCitiesLayer: function(cods, all=false){
		let STYLE_UGRHI_LAYER = {color: "#545454",fillColor: "#6ecaff", fillOpacity:0.3, weight: 1.5}

    function bounds(){
      setTimeout(_=>{
        if(featureGroupCityLimit.getBounds().isValid()){
          map.fitBounds(featureGroupCityLimit.getBounds())
        }
      }, 100)
      $(".loader-layer").hide();
    }
    
    //função para adicionar geometrias ao mapa CASO filtrada pelo usuário
    let addToMap = (cods, all = false) =>{
      featureGroupUgrhiLimit.clearLayers()
      Object.values(this.citys_features_list).forEach(feature=>{
        if(all || cods.includes(feature.cod_ibge.toString())){
          featureGroupCityLimit.addLayer(feature)
        }
      })
    }

    //featureGroupUgrhiLimit ta global :(
    let map_c = new MapComponent({container: '.whatever'}) //n será usado para criar mapa

    //limpando camada de ugrhis
    featureGroupCityLimit.clearLayers()

    //verificando dos códigos filtrados, qual eu NÃO tenho a geometria
    let citys_needed
    if(all){
      citys_needed = null
    } else {
      citys_needed = cods.filter(c=> !Object.values(this.citys_features_list).some(item=>item.cod_ibge == c))
    }
    

    //se tem alguma geometria que eu não tenho, buscar
    if(citys_needed == null || citys_needed.length > 0){
      map_c.getLimitFeature('city', {simplified:true, cods_ibge:citys_needed},STYLE_UGRHI_LAYER).then(featureGroup=>{        
        
        //adicinando novas geometrias a camada de geometrias
        featureGroup.eachLayer(feature=>{
          this.citys_features_list[feature.cod_ibge] = feature
        })
        
        addToMap(cods, all)

        //bounds
        bounds()
      })
    } else {
      addToMap(cods, all)

      //bounds
      bounds()
    }
  },
  loadMonitoredSpotsMarkers: function(){
    markers_monitored_spots.clearLayers();
		$(".loader-monitored").show();
		if(monitored_spots.length > 0){
			createMarkers(monitored_spots)
			$(".loader-monitored").hide();
		} else {
			$.ajax({
			  url: "/sibh/api/v1/station_prefixes",
			  // data: {pluviometricas: true, transmission_status: [0], telemetry: true}
        data: {pluviometricas: true, transmission_status: [0]},
        success: function(data){
          monitored_spots = data
  				createMarkers(monitored_spots)
  				$(".loader-monitored").hide();
        },
        error: function(e){
          console.log('erro ao carregar pontos monitorados')
        }
			})
		}

    function createMarkers(monitored_spots){
      $.each(monitored_spots, function(index, station_prefix){
        var options = {
          borderWidth: 2,
          innerIconStyle: 'margin-top:0;font-size:13px;',
          borderColor: '#ab2072',
          backgroundColor: 'grey',
          iconShape: 'circle-dot'
        };
        var opcoes_marker = {
          title: station_prefix.prefix,
          station_id: station_prefix.id,
          icon: L.BeautifyIcon.icon(options)
        };

        var marker = L.marker([station_prefix.station.latitude, station_prefix.station.longitude],opcoes_marker).bindPopup(
          "Prefixo: <b>" +station_prefix.prefix+
          "</b><br>Município: <b>"+station_prefix.station.city.name+"</b>"
        );

        markers_monitored_spots.addLayer(marker);

      })
    }

    
  },
  // ###################################### LOAD LAYERS FOR MAP FUNCTIONS #########################################
  showMakerOnMap(prefix){
    let marker = markers_group.getLayers().filter(x=>x.options.title == prefix)[0]
    console.log(markers_group.getLayers(), prefix);
    if(marker){
      map.flyTo(marker.getLatLng(),13, {animate:false})
      marker.openPopup()
    } else {
      console.log('marker nao lcoalziado');
    }
    
  }

}
